import { Flex, Tag, Text } from '@chakra-ui/react';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';

interface BlogTagFilterProps {
  tags: string[];
  activeTag?: string;
  onTagChange: (tag: string | undefined) => void;
}

export const BlogTagFilter = ({ tags, activeTag, onTagChange }: BlogTagFilterProps) => {
  const { _ } = useLingui();

  if (tags.length === 0) return null;

  return (
    <Flex gap={2} flexWrap="wrap" mb={8}>
      <TagPill
        label={_(msg({ id: 'blog.filter.all', message: 'All' }))}
        isActive={!activeTag}
        onClick={() => onTagChange(undefined)}
      />
      {tags.map((tag) => (
        <TagPill
          key={tag}
          label={tag}
          isActive={activeTag?.toLowerCase() === tag.toLowerCase()}
          onClick={() =>
            onTagChange(activeTag?.toLowerCase() === tag.toLowerCase() ? undefined : tag)
          }
        />
      ))}
    </Flex>
  );
};

const TagPill = ({
  label,
  isActive,
  onClick,
}: {
  label: string;
  isActive: boolean;
  onClick: () => void;
}) => (
  // Тег-кнопка на общей подложке «выбрано» вместо своей фиолетовой: тег блога — это тоже
  // «по этому ищут», и выбранный отличается от остальных тем же, чем активный пункт меню.
  <Tag.Root
    asChild
    size="lg"
    minH="44px"
    minW="44px"
    cursor="pointer"
    bgColor={isActive ? 'bg.selected' : 'bg.emphasized'}
    color={isActive ? 'fg' : 'fg.secondary'}
    _hover={isActive ? {} : { bg: 'bg.raised', color: 'fg' }}
  >
    <button type="button" aria-pressed={isActive} onClick={onClick}>
      <Text>{label}</Text>
    </button>
  </Tag.Root>
);
